import { defaultTemplateConfig } from '@/mocks/template-config';
import { useCompanyData } from '@/hooks/useCompanyData';
import TopSection from './components/TopSection';
import LoginCard from './components/LoginCard';
import InstitutionalSection from './components/InstitutionalSection';
import FooterSection from './components/FooterSection';

export default function Home() {
  const config = defaultTemplateConfig;
  const { data: companyData } = useCompanyData();

  return (
    <div className="min-h-screen bg-brand-dark font-sans">
      {/* Hero Section with Background */}
      <div className="relative min-h-screen flex flex-col">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img
            src={config.top.bannerImage}
            alt="Segurança residencial"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-brand-dark/80 via-brand-dark/60 to-brand-dark/90" />
        </div>

        {/* Top Content */}
        <TopSection config={config.top} companyData={companyData} />

        {/* Login Card */}
        <LoginCard />
      </div>

      {/* Institutional Section */}
      <InstitutionalSection config={config.institutional} />

      {/* Footer */}
      <FooterSection config={config.footer} specialties={config.specialties} companyData={companyData} />
    </div>
  );
}